module.exports = [{"data":"2020-01-01"},{"data":"2020-01-27"},{"data":"2021-01-01"},{"data":"2021-01-26"},{"data":"2021-04-02"},{"data":"2021-04-21"},{"data":"2021-05-01"},{"data":"2021-06-03"},{"data":"2021-07-09"},{"data":"2021-09-07"},{"data":"2021-10-12"},{"data":"2021-10-28"},{"data":"2021-11-02"},{"data":"2021-11-15"},{"data":"2021-11-20"},{"data":"2021-12-25"}]


//////////////////
// WEBPACK FOOTER
// ./static/support/sample-data/feriados.json
// module id = sTdX
// module chunks = 5